"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var pbkdf2_1 = require("./pbkdf2");

var MAX_VALUE = 0x7fffffff; // The following is an adaptation of scryptsy
// See: https://www.npmjs.com/package/scryptsy

function blockmix_salsa8(BY, Yi, r, x, _X) {
  var i;
  arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);

  for (i = 0; i < 2 * r; i++) {
    blockxor(BY, i * 16, _X, 16);
    salsa20_8(_X, x);
    arraycopy(_X, 0, BY, Yi + i * 16, 16);
  }

  for (i = 0; i < r; i++) {
    arraycopy(BY, Yi + i * 2 * 16, BY, i * 16, 16);
  }

  for (i = 0; i < r; i++) {
    arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
  }
}

function R(a, b) {
  return a << b | a >>> 32 - b;
}

function salsa20_8(B, x) {
  arraycopy(B, 0, x, 0, 16);

  for (var i = 8; i > 0; i -= 2) {
    x[4] ^= R(x[0] + x[12], 7);
    x[8] ^= R(x[4] + x[0], 9);
    x[12] ^= R(x[8] + x[4], 13);
    x[0] ^= R(x[12] + x[8], 18);
    x[9] ^= R(x[5] + x[1], 7);
    x[13] ^= R(x[9] + x[5], 9);
    x[1] ^= R(x[13] + x[9], 13);
    x[5] ^= R(x[1] + x[13], 18);
    x[14] ^= R(x[10] + x[6], 7);
    x[2] ^= R(x[14] + x[10], 9);
    x[6] ^= R(x[2] + x[14], 13);
    x[10] ^= R(x[6] + x[2], 18);
    x[3] ^= R(x[15] + x[11], 7);
    x[7] ^= R(x[3] + x[15], 9);
    x[11] ^= R(x[7] + x[3], 13);
    x[15] ^= R(x[11] + x[7], 18);
    x[1] ^= R(x[0] + x[3], 7);
    x[2] ^= R(x[1] + x[0], 9);
    x[3] ^= R(x[2] + x[1], 13);
    x[0] ^= R(x[3] + x[2], 18);
    x[6] ^= R(x[5] + x[4], 7);
    x[7] ^= R(x[6] + x[5], 9);
    x[4] ^= R(x[7] + x[6], 13);
    x[5] ^= R(x[4] + x[7], 18);
    x[11] ^= R(x[10] + x[9], 7);
    x[8] ^= R(x[11] + x[10], 9);
    x[9] ^= R(x[8] + x[11], 13);
    x[10] ^= R(x[9] + x[8], 18);
    x[12] ^= R(x[15] + x[14], 7);
    x[13] ^= R(x[12] + x[15], 9);
    x[14] ^= R(x[13] + x[12], 13);
    x[15] ^= R(x[14] + x[13], 18);
  }

  for (var _i = 0; _i < 16; ++_i) {
    B[_i] += x[_i];
  }
} // naive approach... going back to loop unrolling may yield additional performance


function blockxor(S, Si, D, len) {
  for (var i = 0; i < len; i++) {
    D[i] ^= S[Si + i];
  }
}

function arraycopy(src, srcPos, dest, destPos, length) {
  while (length--) {
    dest[destPos++] = src[srcPos++];
  }
}

function ensureInteger(value, name) {
  var intValue = parseInt(value, 10);

  if (value !== intValue) {
    throw new Error('invalid ' + name);
  }

  return intValue;
} // N = Cpu cost, r = Memory cost, p = parallelization cost
// callback(error, progress, key)


function scrypt(password, salt, N, r, p, dkLen, callback) {
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, reject) {
      var b, B, i, j, XY, V, Yi, x, _X, totalOps, currentOp, lastPercent10, stop, state, i0, i1, Bi, limit, nextTick, incrementalSMix;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              N = ensureInteger(N, 'N');
              r = ensureInteger(r, 'r');
              p = ensureInteger(p, 'p');
              dkLen = ensureInteger(dkLen, 'dkLen');

              if (N === 0 || (N & N - 1) !== 0) {
                reject(new Error('N must be power of 2'));
              }

              if (N > MAX_VALUE / 128 / r) {
                reject(new Error('N too large'));
              }

              if (r > MAX_VALUE / 128 / p) {
                reject(new Error('r too large'));
              }

              _context2.t0 = _toConsumableArray;
              _context2.next = 10;
              return pbkdf2_1.pbkdf2(password, salt, 1, p * 128 * r);

            case 10:
              _context2.t1 = _context2.sent;
              b = (0, _context2.t0)(_context2.t1);
              B = new Uint32Array(p * 32 * r);

              for (i = 0; i < B.length; i++) {
                j = i * 4;
                B[i] = (b[j + 3] & 0xff) << 24 | (b[j + 2] & 0xff) << 16 | (b[j + 1] & 0xff) << 8 | (b[j + 0] & 0xff) << 0;
              }

              XY = new Uint32Array(64 * r);
              V = new Uint32Array(32 * r * N);
              Yi = 32 * r; // scratch space

              x = new Uint32Array(16); // salsa20_8

              _X = new Uint32Array(16); // blockmix_salsa8

              totalOps = p * N * 2;
              currentOp = 0;
              lastPercent10 = null; // Set this to true to abandon the scrypt on the next step

              stop = false; // State information

              state = 0;
              i0 = 0;
              i1 = 0;
              // How many blockmix_salsa8 can we do per step?
              limit = Math.trunc(1000 / r); // Trick from scrypt-async; if there is a setImmediate shim in place, use it

              nextTick = typeof setImmediate !== 'undefined' ? setImmediate : setTimeout; // This is really all I changed; making scryptsy a state machine so we occasionally
              // stop and give other evnts on the evnt loop a chance to run. ~RicMoo

              incrementalSMix = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var steps, _i2, percent10, _steps, _i3, offset, _j, _percent, _iterator, _step, bb, derivedKey;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!stop) {
                            _context.next = 4;
                            break;
                          }

                          if (callback) {
                            callback(currentOp / totalOps);
                          }

                          reject(new Error('cancelled'));
                          return _context.abrupt("return");

                        case 4:
                          _context.t0 = state;
                          _context.next = _context.t0 === 0 ? 7 : _context.t0 === 1 ? 11 : _context.t0 === 2 ? 26 : 53;
                          break;

                        case 7:
                          // for (var i = 0; i < p; i++)...
                          Bi = i0 * 32 * r;
                          arraycopy(B, Bi, XY, 0, Yi); // ROMix - 1

                          state = 1; // Move to ROMix 2

                          i1 = 0;

                        case 11:
                          // Run up to 1000 steps of the first inner smix loop
                          steps = N - i1;

                          if (steps > limit) {
                            steps = limit;
                          }

                          for (_i2 = 0; _i2 < steps; _i2++) {
                            // ROMix - 2
                            arraycopy(XY, 0, V, (i1 + _i2) * Yi, Yi); // ROMix - 3

                            blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 4
                          } // for (var i = 0; i < N; i++)


                          i1 += steps;
                          currentOp += steps; // Call the callback with the progress (optionally stopping us)

                          percent10 = Math.trunc(1000 * currentOp / totalOps);

                          if (!(percent10 !== lastPercent10)) {
                            _context.next = 22;
                            break;
                          }

                          if (callback) {
                            stop = callback(currentOp / totalOps);
                          }

                          if (!stop) {
                            _context.next = 21;
                            break;
                          }

                          return _context.abrupt("break", 53);

                        case 21:
                          lastPercent10 = percent10;

                        case 22:
                          if (!(i1 < N)) {
                            _context.next = 24;
                            break;
                          }

                          return _context.abrupt("break", 53);

                        case 24:
                          i1 = 0; // Move to ROMix 6

                          state = 2;

                        case 26:
                          // Run up to 1000 steps of the second inner smix loop
                          _steps = N - i1;

                          if (_steps > limit) {
                            _steps = limit;
                          }

                          for (_i3 = 0; _i3 < _steps; _i3++) {
                            // ROMix - 6
                            offset = (2 * r - 1) * 16; // ROMix - 7

                            _j = XY[offset] & N - 1;
                            blockxor(V, _j * Yi, XY, Yi); // ROMix - 8 (inner)

                            blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 9 (outer)
                          } // for (var i = 0; i < N; i++)...


                          i1 += _steps;
                          currentOp += _steps; // Call the callback with the progress (optionally stopping us)

                          _percent = Math.trunc(1000 * currentOp / totalOps);

                          if (!(_percent !== lastPercent10)) {
                            _context.next = 37;
                            break;
                          }

                          if (callback) {
                            stop = callback(currentOp / totalOps);
                          }

                          if (!stop) {
                            _context.next = 36;
                            break;
                          }

                          return _context.abrupt("break", 53);

                        case 36:
                          lastPercent10 = _percent;

                        case 37:
                          if (!(i1 < N)) {
                            _context.next = 39;
                            break;
                          }

                          return _context.abrupt("break", 53);

                        case 39:
                          arraycopy(XY, 0, B, Bi, Yi); // ROMix - 10
                          // for (var i = 0; i < p; i++)...

                          i0++;

                          if (!(i0 < p)) {
                            _context.next = 44;
                            break;
                          }

                          state = 0;
                          return _context.abrupt("break", 53);

                        case 44:
                          b = [];
                          _iterator = _createForOfIteratorHelper(B);

                          try {
                            for (_iterator.s(); !(_step = _iterator.n()).done;) {
                              bb = _step.value;
                              b.push(bb >> 0 & 0xff);
                              b.push(bb >> 8 & 0xff);
                              b.push(bb >> 16 & 0xff);
                              b.push(bb >> 24 & 0xff);
                            }
                          } catch (err) {
                            _iterator.e(err);
                          } finally {
                            _iterator.f();
                          }

                          _context.next = 49;
                          return pbkdf2_1.pbkdf2(password, Buffer.from(b), 1, dkLen);

                        case 49:
                          derivedKey = _context.sent;

                          // Done; don't break (which would reschedule)
                          if (callback) {
                            callback(1.0);
                          }

                          resolve(derivedKey);
                          return _context.abrupt("return");

                        case 53:
                          // Schedule the next steps
                          nextTick(incrementalSMix);

                        case 54:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function incrementalSMix() {
                  return _ref2.apply(this, arguments);
                };
              }(); // Bootstrap the incremental smix


              incrementalSMix();

            case 30:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}

exports.scrypt = scrypt;